import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)
dayjs.extend(timezone)
const timeZone = {
  value: undefined, // 时区值
}
export const formatTimeStr = (date, format = 'MM. DD, YYYY HH:mm:ss') => {
  if (!timeZone.value) {
    const guessTimeZone = dayjs.tz.guess()
    timeZone.value = guessTimeZone.includes('Etc') ? 'America/Los_Angeles' : guessTimeZone
  }
  const currentTime = dayjs(date)
  return dayjs.tz(currentTime, 'Asia/Shanghai').tz(timeZone.value).format(format)
}

export const formatTimeStrUSA = (date, format = 'MM. DD, YYYY HH:mm:ss') => {
  if (!timeZone.value) {
    const guessTimeZone = dayjs.tz.guess()
    timeZone.value = guessTimeZone.includes('Etc') ? 'America/Los_Angeles' : guessTimeZone
  }
  const currentTime = dayjs(date)
  const result = dayjs.tz(currentTime, 'Asia/Shanghai').tz(timeZone.value).format(format)
  const monthsArr = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  let resultUSA = ''
  let monthsStr = result.substring(0, 2)
  let monthsStrUSA = ''
  if (monthsStr.substring(0, 1).includes('0')) {
    monthsStrUSA = monthsArr[Number(monthsStr.substring(1)) - 1]
  } else {
    monthsStrUSA = monthsArr[Number(monthsStr) - 1]
  }
  resultUSA = result.replace(`${monthsStr}`, monthsStrUSA)
  return resultUSA
}
